const shopFooter = {
  displayField: 'header',
  name: 'Shop Footer',
  description: 'Footer for shops only.  **Not shop groups.',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'richText',
      name: 'Additional Legal',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [
            'bold',
            'italic',
            'underline',
            'code',
            'superscript',
            'subscript'
          ],
          message: 'Only bold, italic, underline, code, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-1',
            'heading-2',
            'heading-3',
            'heading-4',
            'heading-5',
            'heading-6',
            'unordered-list',
            'ordered-list',
            'blockquote',
            'hr',
            'table',
            'hyperlink',
            'asset-hyperlink',
            'embedded-asset-block',
            'entry-hyperlink'
          ],
          message: 'Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, unordered list, ordered list, quote, horizontal rule, table, link to Url, link to asset, asset, and link to entry nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'columnOne',
      name: 'Column One',
      type: 'Array',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'columnTwo',
      name: 'Column Two',
      type: 'Array',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'columnThree',
      name: 'Column Three',
      type: 'Array',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'columnFour',
      name: 'Column Four',
      type: 'Array',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'columnFive',
      name: 'Column Five',
      type: 'Array',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'columnSix',
      name: 'Column Six',
      type: 'Array',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'link' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentTypeField: {
        columnSix: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        columnOne: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        columnFive: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        columnTwo: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        columnFour: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        columnThree: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ]
      }
    }
  },
  sys: {
    id: 'shopFooter',
    version: 18,
    updatedAt: '2023-11-24T21:40:39.311Z'
  }
};
export default shopFooter;